import React from 'react';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement>;

const BackButton: React.FC<Props> = ({ className, type, ...rest }) => {
  const classes = ['back-btn', className].filter(Boolean).join(' ');
  return <button type={type ?? 'button'} className={classes} {...rest} />;
};

export default BackButton;
